import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-5 tw-pl-5 tw-pt-5 tw-pb-5 mt-3",
  style: {"margin-left":"2rem"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalUsers"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_12 = { class: "tw-flex tw-gap-3" }
const _hoisted_13 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_15 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_17 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_19 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_35 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_36 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_37 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "modal fade",
  id: "exampleModalMessageMAILSCENARIO",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog" }
const _hoisted_48 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_53 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_55 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_57 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_58 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_59 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_61 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenario2",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenario2",
  "aria-hidden": "true"
}
const _hoisted_64 = { class: "modal-dialog" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_67 = { class: "modal-body" }
const _hoisted_68 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_69 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_71 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_74 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_75 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_76 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_77 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_78 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE LOAN ORIGINATOR")
  ])
], -1)
const _hoisted_80 = { class: "data" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_82 = { class: "data" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_84 = { class: "data" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM", -1)
const _hoisted_86 = { class: "data" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_88 = { class: "data" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("td", null, "NAME-MLO", -1)
const _hoisted_90 = { class: "data" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_92 = { class: "data" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL-MLO", -1)
const _hoisted_94 = { class: "data" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM-MLO", -1)
const _hoisted_96 = { class: "data" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_98 = { class: "data" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_100 = { class: "data" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_102 = { class: "data" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("td", null, "PMI", -1)
const _hoisted_104 = { class: "data" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-D&I", -1)
const _hoisted_106 = { class: "data" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_108 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CUSTOMER INFORMATION")
  ])
], -1)
const _hoisted_110 = { class: "data" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_112 = { class: "data" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_114 = { class: "data" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_116 = {
  key: 0,
  class: "table table-bordered border-0 mb-0 table-edit"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FINANCING INFORMATION")
  ])
], -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-PROGRAM", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-YEARS", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_121 = {
  key: 0,
  class: "table table-bordered border-0 mb-3 table-edit mt-3"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "INCOME TYPE-HOURS")
  ])
], -1)
const _hoisted_123 = { class: "data" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("td", null, "PAYMENT FOR HOUR", -1)
const _hoisted_125 = { class: "data" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("td", null, "HOURS FOR DAY", -1)
const _hoisted_127 = { class: "data" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("td", null, "DAYS FOR WEEK", -1)
const _hoisted_129 = { class: "data" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("td", null, "WEEKS FOR MONTHS", -1)
const _hoisted_131 = { class: "data" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("td", null, "MONTHS FOR YEAR", -1)
const _hoisted_133 = { class: "data" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_135 = {
  key: 0,
  class: "table table-bordered border-0 mb-3 table-edit mt-3"
}
const _hoisted_136 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "INCOME TYPE-WEEK")
  ])
], -1)
const _hoisted_137 = { class: "data" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("td", null, "PAYMENT FOR WEEK", -1)
const _hoisted_139 = { class: "data" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("td", null, "WEEKS FOR MONTHS", -1)
const _hoisted_141 = { class: "data" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("td", null, "MONTHS FOR YEAR", -1)
const _hoisted_143 = { class: "data" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_145 = {
  key: 0,
  class: "table table-bordered border-0 mb-3 table-edit mt-3"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "INCOME TYPE-BYWEEKLY")
  ])
], -1)
const _hoisted_147 = { class: "data" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("td", null, "PAYMENT FOR BYWEEKLY", -1)
const _hoisted_149 = { class: "data" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("td", null, "BYWEEKLY FOR MONTHS", -1)
const _hoisted_151 = { class: "data" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("td", null, "MONTHS FOR YEAR", -1)
const _hoisted_153 = { class: "data" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_155 = {
  key: 0,
  class: "table table-bordered border-0 mb-3 table-edit mt-3"
}
const _hoisted_156 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "INCOME TYPE-MOTHS")
  ])
], -1)
const _hoisted_157 = { class: "data" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("td", null, "PAYMENT FOR MONTHS", -1)
const _hoisted_159 = { class: "data" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("td", null, "MONTHS FOR YEAR", -1)
const _hoisted_161 = { class: "data" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_163 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "TOTAL MONTHLY INCOME $")
  ])
], -1)
const _hoisted_165 = { class: "data" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_167 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "TOTAL MONTHLY INCOME-CUSTOMERS")
  ])
], -1)
const _hoisted_169 = { class: "data" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("td", null, "MONTHLY-INCOME $", -1)
const _hoisted_171 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FAMILY MONTHLY EXPENSES $")
  ])
], -1)
const _hoisted_173 = { class: "data" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("td", null, "TOTAL-EXPENSES", -1)
const _hoisted_175 = { class: "table table-bordered border-0 mb-3 table-edit mt-3" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "ESTIMATED MORTGAGE")
  ])
], -1)
const _hoisted_177 = { class: "data" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("td", null, "MORTGAGE LOAN ESTIMATED", -1)
const _hoisted_179 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, "DTI RATIO ", -1)
const _hoisted_181 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_182 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleDtiTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY")
], -1)
const _hoisted_184 = {
  class: "collapse",
  id: "collapseExampleDtiTittle"
}
const _hoisted_185 = { class: "card card-body" }
const _hoisted_186 = { class: "tw-flex tw-justify-around" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_188 = ["onClick"]
const _hoisted_189 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample7",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("INSPECTOR")
], -1)
const _hoisted_191 = {
  class: "collapse",
  id: "collapseExample7"
}
const _hoisted_192 = { class: "card card-body" }
const _hoisted_193 = { class: "tw-flex tw-justify-around" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_196 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR", -1)
const _hoisted_198 = { class: "tw-px-4" }
const _hoisted_199 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_200 = { class: "tw-w-full" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_202 = ["value"]
const _hoisted_203 = { class: "tw-w-full" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_205 = { class: "tw-w-full" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_208 = ["value"]
const _hoisted_209 = { class: "tw-w-full" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_212 = ["value"]
const _hoisted_213 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_214 = ["disabled"]
const _hoisted_215 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_216 = {
  key: 0,
  class: "tw-w-full table-edit"
}
const _hoisted_217 = ["colspan"]
const _hoisted_218 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_219 = [
  _hoisted_218
]
const _hoisted_220 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_222 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_223 = { key: 0 }
const _hoisted_224 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER", -1)
const _hoisted_226 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_227 = { key: 0 }
const _hoisted_228 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL", -1)
const _hoisted_230 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_231 = { key: 0 }
const _hoisted_232 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_233 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_234 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_235 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE", -1)
const _hoisted_237 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_238 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_239 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MINIMUM DOWN PAYMENT", -1)
const _hoisted_240 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_241 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_242 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI", -1)
const _hoisted_243 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_244 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_245 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO D&I", -1)
const _hoisted_246 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_247 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_248 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO", -1)
const _hoisted_249 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_250 = {
  key: 0,
  class: "tw-even:bg-[#eaeaea] tw-odd:bg-white tw-bg-[#00a0da] tw-text-white"
}
const _hoisted_251 = ["colspan"]
const _hoisted_252 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-start tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, "  ", -1)
const _hoisted_254 = { class: "tw-text-start tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_255 = ["type", "onUpdate:modelValue"]
const _hoisted_256 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_257 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_258 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_259 = { class: "tw-border-none tw-px-4" }
const _hoisted_260 = ["onClick"]
const _hoisted_261 = {
  key: 1,
  class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]"
}
const _hoisted_262 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "tw-even:bg-gray-50 tw-odd:bg-white" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NO MLO'S TABLES FOUND ")
  ])
], -1)
const _hoisted_263 = [
  _hoisted_262
]
const _hoisted_264 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER", -1)
const _hoisted_266 = { class: "tw-px-4" }
const _hoisted_267 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-border tw-border-b-[#545454] tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-pb-1 tw-mt-7 tw-text-left" }, " PERSONAL DATA", -1)
const _hoisted_268 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_269 = { class: "tw-w-full" }
const _hoisted_270 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_271 = ["onUpdate:modelValue"]
const _hoisted_272 = { class: "tw-w-full" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_274 = ["onUpdate:modelValue"]
const _hoisted_275 = { class: "tw-w-full" }
const _hoisted_276 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_277 = ["onUpdate:modelValue"]
const _hoisted_278 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_279 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FINANCING INFORMATION", -1)
const _hoisted_280 = {
  key: 0,
  class: "tw-px-4"
}
const _hoisted_281 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_282 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM", -1)
const _hoisted_284 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_285 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_286 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS", -1)
const _hoisted_287 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_288 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_290 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("div", { class: "tw-mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "INCOME TYPE:")
], -1)
const _hoisted_292 = { class: "tw-flex tw-justify-center tw-gap-[50px]" }
const _hoisted_293 = ["href"]
const _hoisted_294 = ["data-bs-target"]
const _hoisted_295 = { class: "row" }
const _hoisted_296 = { class: "col" }
const _hoisted_297 = ["id"]
const _hoisted_298 = { class: "card card-body tw-ml-5 tw-mt-2" }
const _hoisted_299 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR HOUR"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "HOURS FOR DAY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DAYS FOR WEEK"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WEEKS FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_301 = { class: "data" }
const _hoisted_302 = ["onUpdate:modelValue"]
const _hoisted_303 = ["onUpdate:modelValue"]
const _hoisted_304 = ["onUpdate:modelValue"]
const _hoisted_305 = ["onUpdate:modelValue"]
const _hoisted_306 = { class: "tw-flex tw-justify-around tw-items-center tw-mt-5" }
const _hoisted_307 = ["onClick"]
const _hoisted_308 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_309 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_310 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_311 = ["onClick"]
const _hoisted_312 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_313 = [
  _hoisted_312
]
const _hoisted_314 = ["onClick"]
const _hoisted_315 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_316 = [
  _hoisted_315
]
const _hoisted_317 = { class: "col" }
const _hoisted_318 = ["id"]
const _hoisted_319 = { class: "card card-body tw-mr-5 tw-mt-2" }
const _hoisted_320 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR WEEK"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WEEKS FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_322 = { class: "data" }
const _hoisted_323 = ["onUpdate:modelValue"]
const _hoisted_324 = ["onUpdate:modelValue"]
const _hoisted_325 = { class: "tw-flex tw-justify-around tw-items-center tw-mt-5" }
const _hoisted_326 = ["onClick"]
const _hoisted_327 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_328 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_329 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_330 = ["onClick"]
const _hoisted_331 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_332 = [
  _hoisted_331
]
const _hoisted_333 = ["onClick"]
const _hoisted_334 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_335 = [
  _hoisted_334
]
const _hoisted_336 = { class: "tw-mt-[40px] tw-mb-5" }
const _hoisted_337 = { class: "tw-flex tw-justify-center tw-gap-[50px]" }
const _hoisted_338 = ["href"]
const _hoisted_339 = ["data-bs-target"]
const _hoisted_340 = { class: "row" }
const _hoisted_341 = { class: "col" }
const _hoisted_342 = ["id"]
const _hoisted_343 = { class: "card card-body tw-ml-5 tw-mt-5" }
const _hoisted_344 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR BYWEEKLY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "BYWEEKLY FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_346 = { class: "data" }
const _hoisted_347 = ["onUpdate:modelValue"]
const _hoisted_348 = ["onUpdate:modelValue"]
const _hoisted_349 = { class: "tw-flex mt-3 tw-items-center tw-justify-around" }
const _hoisted_350 = ["onClick"]
const _hoisted_351 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_352 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_353 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_354 = ["onClick"]
const _hoisted_355 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_356 = [
  _hoisted_355
]
const _hoisted_357 = ["onClick"]
const _hoisted_358 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_359 = [
  _hoisted_358
]
const _hoisted_360 = { class: "col" }
const _hoisted_361 = ["id"]
const _hoisted_362 = { class: "card card-body tw-mr-5 tw-mt-5" }
const _hoisted_363 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_364 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_365 = { class: "data" }
const _hoisted_366 = ["onUpdate:modelValue"]
const _hoisted_367 = { class: "tw-flex mt-3 tw-items-center tw-justify-around" }
const _hoisted_368 = ["onClick"]
const _hoisted_369 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_370 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_371 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_372 = ["onClick"]
const _hoisted_373 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_374 = [
  _hoisted_373
]
const _hoisted_375 = ["onClick"]
const _hoisted_376 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_377 = [
  _hoisted_376
]
const _hoisted_378 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_379 = ["onClick"]
const _hoisted_380 = { class: "tw-items-center tw-gap-4" }
const _hoisted_381 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL MONTHLY INCOME $: ", -1)
const _hoisted_382 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_383 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " TOTAL MONTHLY INCOME $", -1)
const _hoisted_384 = { class: "tw-px-4" }
const _hoisted_385 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_386 = { class: "tw-items-center tw-gap-4" }
const _hoisted_387 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL MONTHLY INCOME $: ", -1)
const _hoisted_388 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_389 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " FAMILY MONTHLY EXPENSES", -1)
const _hoisted_390 = { class: "tw-px-4" }
const _hoisted_391 = {
  key: 0,
  class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]"
}
const _hoisted_392 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_393 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_394 = ["type", "value", "disabled"]
const _hoisted_395 = {
  key: 1,
  class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]"
}
const _hoisted_396 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "tw-even:bg-gray-50 tw-odd:bg-white" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NO MLO'S TABLES FOUND ")
  ])
], -1)
const _hoisted_397 = [
  _hoisted_396
]
const _hoisted_398 = { class: "tw-flex tw-justify-evenly tw-items-center tw-mt-[35px] tw-mb-[35px] tw-w-full tw-gap-[140px]" }
const _hoisted_399 = { class: "tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_400 = { key: 0 }
const _hoisted_401 = { class: "tw-items-center tw-gap-4" }
const _hoisted_402 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL EXPENSES $: ", -1)
const _hoisted_403 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_404 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " ESTIMATED MORTGAGE", -1)
const _hoisted_405 = { class: "tw-px-4" }
const _hoisted_406 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_407 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[15px] tw-p-[10px]" }, "MORTGAGE LOAN ESTIMATED")
], -1)
const _hoisted_408 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_409 = { class: "tw-items-center tw-gap-4" }
const _hoisted_410 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " RESULT: ", -1)
const _hoisted_411 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_412 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-fixed tw-top-0 tw-left-0", { 'tw-w-full tw-h-full': _ctx.loaderConfig.isLoading }])
    }, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": !_ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"])
    ], 2),
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''DTI RATIO''",
      helpVideo: "https://www.realtortools.org/media/VideoDtiRatio.mp4"
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_ResidentialView, { header: false })
    ]),
    _hoisted_2,
    _createElementVNode("button", _hoisted_3, [
      _createElementVNode("img", {
        class: "tw-w-[40px] tw-mr-3",
        src: require('@/assets/Images/iconos-02.png'),
        alt: ""
      }, null, 8, _hoisted_4),
      _createTextVNode(" RECORD ")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_ctx.scenario.users)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "w-100",
                          range: "",
                          modelValue: _ctx.configDatePicker.date,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                            _ctx.changeDate
                          ],
                          placeholder: "Enter date range..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getScenarioUsers())),
                      class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                    }, "Filter"),
                    _createElementVNode("table", _hoisted_19, [
                      _hoisted_20,
                      (_ctx.scenario.users.results && _ctx.scenario.users.results.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal4858",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.loadScenarios(user))
                                  }, _hoisted_24, 8, _hoisted_22)
                                ])
                              ]))
                            }), 256))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_25, _hoisted_27))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.scenario.userScenarios && _ctx.scenario.userScenarios.results)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("table", _hoisted_37, [
                            _hoisted_38,
                            (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("a", {
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#exampleModalEscenario2",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                        }, _hoisted_42, 8, _hoisted_40)
                                      ])
                                    ]))
                                  }), 256))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "53",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.message]
                ])
              ])
            ]),
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                (_ctx.scenarioMail.file)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_59, [
                      _hoisted_60,
                      _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  disabled: _ctx.v$.scenarioMail.$invalid,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
                }, "SEND MESSAGE", 8, _hoisted_62)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printScenario())),
                    class: "block"
                  }, [
                    _hoisted_70,
                    _createTextVNode("PRINT")
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.generateMail()))
                  }, [
                    _hoisted_72,
                    _createTextVNode("SEND")
                  ]),
                  _createVNode(_component_vue3_html2pdf, {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": false,
                    "pdf-quality": 2,
                    "pdf-format": "a4",
                    "pdf-content-width": "800px",
                    "manual-pagination": true,
                    onBeforeDownload: _cache[11] || (_cache[11] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                    ref: "html2PdfLoan"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_73
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  (_ctx.scenario.scenarioData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("table", _hoisted_78, [
                            _hoisted_79,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_80, [
                                _hoisted_81,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedProperty.name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_82, [
                                _hoisted_83,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.score), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_84, [
                                _hoisted_85,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.program_name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_86, [
                                _hoisted_87,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedYears.name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_88, [
                                _hoisted_89,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.username
                                                            + " " +
                                                            _ctx.scenario.scenarioData.mortgage_information.selectedUser.lastname), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.phonenumber), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_92, [
                                _hoisted_93,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.email), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_94, [
                                _hoisted_95,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.program_name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_96, [
                                _hoisted_97,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.interes_rate), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_98, [
                                _hoisted_99,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.minimum_down_paymentlower), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_100, [
                                _hoisted_101,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.minimum_down_paymenthigher), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_102, [
                                _hoisted_103,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.average_mip_pmi), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_104, [
                                _hoisted_105,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.backend_ratio), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_106, [
                                _hoisted_107,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.maximum_loan), 1)
                              ])
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.scenarioData.financial_information.customers, (customer, w) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              _createElementVNode("table", _hoisted_108, [
                                _hoisted_109,
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", _hoisted_110, [
                                    _hoisted_111,
                                    _createElementVNode("td", null, _toDisplayString(customer.customer.name), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_112, [
                                    _hoisted_113,
                                    _createElementVNode("td", null, _toDisplayString(customer.customer.phone), 1)
                                  ]),
                                  _createElementVNode("tr", _hoisted_114, [
                                    _hoisted_115,
                                    _createElementVNode("td", null, _toDisplayString(customer.customer.email), 1)
                                  ])
                                ])
                              ]),
                              (w == 0)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_116, [
                                    _hoisted_117,
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _hoisted_118,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.program_name), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_119,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedYears.name), 1)
                                      ]),
                                      _createElementVNode("tr", null, [
                                        _hoisted_120,
                                        _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage_information.selectedUser.interes_rate), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.hours, (a) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  (!_ctx.incomeTypeTableEmpty(a))
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_121, [
                                        _hoisted_122,
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_123, [
                                            _hoisted_124,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_VueNumberFormat, {
                                                disabled: true,
                                                value: a.paymentForHour,
                                                "onUpdate:value": ($event: any) => ((a.paymentForHour) = $event),
                                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                              }, null, 8, ["value", "onUpdate:value", "options"])
                                            ])
                                          ]),
                                          _createElementVNode("tr", _hoisted_125, [
                                            _hoisted_126,
                                            _createElementVNode("td", null, _toDisplayString(a.hoursForWeek), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_127, [
                                            _hoisted_128,
                                            _createElementVNode("td", null, _toDisplayString(a.daysForWeek), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_129, [
                                            _hoisted_130,
                                            _createElementVNode("td", null, _toDisplayString(a.weeksForMonth), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_131, [
                                            _hoisted_132,
                                            _createElementVNode("td", null, _toDisplayString(a.monthsForYear), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_133, [
                                            _hoisted_134,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_VueNumberFormat, {
                                                disabled: true,
                                                value: a.monthlyIncome,
                                                "onUpdate:value": ($event: any) => ((a.monthlyIncome) = $event),
                                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                              }, null, 8, ["value", "onUpdate:value", "options"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.week, (b) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  (!_ctx.incomeTypeTableEmpty(b))
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_135, [
                                        _hoisted_136,
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_137, [
                                            _hoisted_138,
                                            _createElementVNode("td", null, _toDisplayString(b.paymentForWeek), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_139, [
                                            _hoisted_140,
                                            _createElementVNode("td", null, _toDisplayString(b.weeksForMonth), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_141, [
                                            _hoisted_142,
                                            _createElementVNode("td", null, _toDisplayString(b.monthsForYear), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_143, [
                                            _hoisted_144,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_VueNumberFormat, {
                                                disabled: true,
                                                value: b.monthlyIncome,
                                                "onUpdate:value": ($event: any) => ((b.monthlyIncome) = $event),
                                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                              }, null, 8, ["value", "onUpdate:value", "options"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.biweekly, (c) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  (!_ctx.incomeTypeTableEmpty(c))
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_145, [
                                        _hoisted_146,
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_147, [
                                            _hoisted_148,
                                            _createElementVNode("td", null, _toDisplayString(c.paymentForWeekly), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_149, [
                                            _hoisted_150,
                                            _createElementVNode("td", null, _toDisplayString(c.byWeeklyForYear), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_151, [
                                            _hoisted_152,
                                            _createElementVNode("td", null, _toDisplayString(c.monthsForYear), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_153, [
                                            _hoisted_154,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_VueNumberFormat, {
                                                disabled: true,
                                                value: c.monthlyIncome,
                                                "onUpdate:value": ($event: any) => ((c.monthlyIncome) = $event),
                                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                              }, null, 8, ["value", "onUpdate:value", "options"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.months, (d) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  (!_ctx.incomeTypeTableEmpty(d))
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_155, [
                                        _hoisted_156,
                                        _createElementVNode("tbody", null, [
                                          _createElementVNode("tr", _hoisted_157, [
                                            _hoisted_158,
                                            _createElementVNode("td", null, _toDisplayString(d.paymentForMonths), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_159, [
                                            _hoisted_160,
                                            _createElementVNode("td", null, _toDisplayString(d.monthsForYear), 1)
                                          ]),
                                          _createElementVNode("tr", _hoisted_161, [
                                            _hoisted_162,
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_VueNumberFormat, {
                                                disabled: true,
                                                value: d.monthlyIncome,
                                                "onUpdate:value": ($event: any) => ((d.monthlyIncome) = $event),
                                                options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                              }, null, 8, ["value", "onUpdate:value", "options"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 256)),
                              _createElementVNode("div", null, [
                                _createElementVNode("table", _hoisted_163, [
                                  _hoisted_164,
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", _hoisted_165, [
                                      _hoisted_166,
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_VueNumberFormat, {
                                          disabled: true,
                                          value: customer.incomeType.totalMonthlyIncome,
                                          "onUpdate:value": ($event: any) => ((customer.incomeType.totalMonthlyIncome) = $event),
                                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                        }, null, 8, ["value", "onUpdate:value", "options"])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ], 64))
                          }), 256)),
                          _createElementVNode("table", _hoisted_167, [
                            _hoisted_168,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_169, [
                                _hoisted_170,
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VueNumberFormat, {
                                    disabled: true,
                                    value: _ctx.scenario.scenarioData.financial_information.totalCustomerMonthlyIncome,
                                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scenario.scenarioData.financial_information.totalCustomerMonthlyIncome) = $event)),
                                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                  }, null, 8, ["value", "options"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_171, [
                            _hoisted_172,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.scenarioData.mortgage_information.selectedUser.listFamilyMonthExpenses, (w) => {
                                return (_openBlock(), _createElementBlock("tr", _hoisted_173, [
                                  _createElementVNode("td", null, _toDisplayString(w.table_text), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_VueNumberFormat, {
                                      disabled: true,
                                      value: w.table_housing_expenses,
                                      "onUpdate:value": ($event: any) => ((w.table_housing_expenses) = $event),
                                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ])
                                ]))
                              }), 256)),
                              _createElementVNode("tr", null, [
                                _hoisted_174,
                                _createElementVNode("td", null, [
                                  _createVNode(_component_VueNumberFormat, {
                                    disabled: true,
                                    value: _ctx.scenario.scenarioData.mortgage_information.selectedUser.totalFamilyMonthExpenses,
                                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.scenario.scenarioData.mortgage_information.selectedUser.totalFamilyMonthExpenses) = $event)),
                                    options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                  }, null, 8, ["value", "options"])
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_175, [
                            _hoisted_176,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_177, [
                                _hoisted_178,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.financial_information.propertyEstimatedMortgage), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_179, [
        _hoisted_180,
        _createElementVNode("div", _hoisted_181, [
          _createElementVNode("div", _hoisted_182, [
            _hoisted_183,
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("div", _hoisted_185, [
                _createElementVNode("div", _hoisted_186, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                      _createTextVNode(),
                      _hoisted_187,
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                        onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                      }, "GET IT", 8, _hoisted_188)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_189, [
            _hoisted_190,
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                      _createTextVNode(),
                      _hoisted_194,
                      _hoisted_195
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_196, [
          _hoisted_197,
          _createElementVNode("div", _hoisted_198, [
            _createElementVNode("div", _hoisted_199, [
              _createElementVNode("div", _hoisted_200, [
                _hoisted_201,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.property) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTableProperties, (tabletype) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: tabletype.id
                    }, _toDisplayString(tabletype.name), 9, _hoisted_202))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.property]
                ])
              ]),
              _createElementVNode("div", _hoisted_203, [
                _hoisted_204,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.score) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters.score]
                ])
              ]),
              _createElementVNode("div", _hoisted_205, [
                _hoisted_206,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filters.program) = $event))
                }, [
                  _hoisted_207,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: program.id
                    }, _toDisplayString(program.name), 9, _hoisted_208))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.program]
                ])
              ]),
              _createElementVNode("div", _hoisted_209, [
                _hoisted_210,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters.year) = $event))
                }, [
                  _hoisted_211,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: year.id
                    }, _toDisplayString(year.name), 9, _hoisted_212))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.year]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_213, [
              _createElementVNode("button", {
                class: "tw-bg-[#00a0da] disabled:tw-bg-[#ccc] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args))),
                disabled: _ctx.listUserSections.length == 0
              }, "RUN", 8, _hoisted_214)
            ]),
            _createElementVNode("div", _hoisted_215, [
              (_ctx.listUserSections.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_216, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                          colspan: _ctx.listUserSections.length + 1
                        }, _hoisted_219, 8, _hoisted_217)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_220, [
                        _hoisted_221,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_222, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_223, _toDisplayString(user.username +
                                                " " + user.lastname), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_224, [
                        _hoisted_225,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_226, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_227, _toDisplayString(user.phonenumber), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_228, [
                        _hoisted_229,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_230, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_231, _toDisplayString(user.email), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_232, [
                        _createElementVNode("td", _hoisted_233, _toDisplayString(_ctx.filters.program_name), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_234, _toDisplayString(user.fha), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_235, [
                        _hoisted_236,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_237, _toDisplayString(user.interes_rate), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_238, [
                        _hoisted_239,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_240, _toDisplayString(user.minimum_down_payment &&
                                            user.minimum_down_payment != "-" ? user.minimum_down_payment + "%" : "-"), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_241, [
                        _hoisted_242,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_243, _toDisplayString(user.average_mip_pmi), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_244, [
                        _hoisted_245,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_246, _toDisplayString(user.backend_ratio), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_247, [
                        _hoisted_248,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_249, _toDisplayString(user.maximum_loan), 1))
                        }), 256))
                      ]),
                      (_ctx.filters.active)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_250, [
                            _createElementVNode("td", {
                              class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3",
                              colspan: _ctx.listUserSections.length + 1
                            }, " FAMILY MONTHLY EXPENSES", 8, _hoisted_251)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.filters.active)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.userFamilyMonthExpenses, (uf) => {
                            return (_openBlock(), _createElementBlock("tr", _hoisted_252, [
                              _hoisted_253,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uf.values, (u) => {
                                return (_openBlock(), _createElementBlock("td", _hoisted_254, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: u.type,
                                    "onUpdate:modelValue": ($event: any) => ((u.value) = $event),
                                    disabled: true
                                  }, null, 8, _hoisted_255), [
                                    [_vModelDynamic, u.value]
                                  ])
                                ]))
                              }), 256))
                            ]))
                          }), 256))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_256, [
                _createElementVNode("tr", _hoisted_257, [
                  _hoisted_258,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                    return (_openBlock(), _createElementBlock("td", _hoisted_259, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.getItData(user)),
                        class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                      }, "GET IT", 8, _hoisted_260)
                    ]))
                  }), 256))
                ])
              ]),
              (_ctx.listUserSections.length == 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_261, _hoisted_263))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.financialInformation.customers, (customer, w) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createElementVNode("div", _hoisted_264, [
              _hoisted_265,
              _createElementVNode("div", _hoisted_266, [
                _hoisted_267,
                _createElementVNode("div", _hoisted_268, [
                  _createElementVNode("div", _hoisted_269, [
                    _hoisted_270,
                    _withDirectives(_createElementVNode("input", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": ($event: any) => ((customer.customer.name) = $event),
                      class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                    }, null, 8, _hoisted_271), [
                      [_vModelText, customer.customer.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_272, [
                    _hoisted_273,
                    _withDirectives(_createElementVNode("input", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": ($event: any) => ((customer.customer.phone) = $event),
                      class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                    }, null, 8, _hoisted_274), [
                      [_vModelText, customer.customer.phone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_275, [
                    _hoisted_276,
                    _withDirectives(_createElementVNode("input", {
                      name: "",
                      id: "",
                      "onUpdate:modelValue": ($event: any) => ((customer.customer.email) = $event),
                      class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                    }, null, 8, _hoisted_277), [
                      [_vModelText, customer.customer.email]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_278, [
              _hoisted_279,
              (w == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
                    _createElementVNode("table", _hoisted_281, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_282, [
                          _hoisted_283,
                          _createElementVNode("td", _hoisted_284, _toDisplayString(_ctx.selection.selectedProgram ? _ctx.selection.selectedProgram.name : ''), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_285, [
                          _hoisted_286,
                          _createElementVNode("td", _hoisted_287, _toDisplayString(_ctx.selection.selectedYears ? _ctx.selection.selectedYears.name : ''), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_288, [
                          _hoisted_289,
                          _createElementVNode("td", _hoisted_290, _toDisplayString(_ctx.selection.selectedUser ? _ctx.selection.selectedUser.interes_rate : ''), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _hoisted_291,
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_292, [
                    _createElementVNode("a", {
                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                      "data-bs-toggle": "collapse",
                      href: '#multiCollapseExample1' + w,
                      role: "button",
                      "aria-expanded": "false",
                      "aria-controls": "multiCollapseExample1"
                    }, "HOURS", 8, _hoisted_293),
                    _createElementVNode("button", {
                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": '#multiCollapseExample2' + w,
                      "aria-expanded": "false",
                      "aria-controls": "multiCollapseExample2"
                    }, "WEEK", 8, _hoisted_294)
                  ]),
                  _createElementVNode("div", _hoisted_295, [
                    _createElementVNode("div", _hoisted_296, [
                      _createElementVNode("div", {
                        class: "collapse multi-collapse",
                        id: 'multiCollapseExample1' + w
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.hours, (hour, j) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_298, [
                            _createElementVNode("table", _hoisted_299, [
                              _hoisted_300,
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_301, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_VueNumberFormat, {
                                      value: hour.paymentForHour,
                                      "onUpdate:value": ($event: any) => ((hour.paymentForHour) = $event),
                                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((hour.hoursForWeek) = $event)
                                    }, null, 8, _hoisted_302), [
                                      [_vModelText, hour.hoursForWeek]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((hour.daysForWeek) = $event)
                                    }, null, 8, _hoisted_303), [
                                      [_vModelText, hour.daysForWeek]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((hour.weeksForMonth) = $event)
                                    }, null, 8, _hoisted_304), [
                                      [_vModelText, hour.weeksForMonth]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((hour.monthsForYear) = $event)
                                    }, null, 8, _hoisted_305), [
                                      [_vModelText, hour.monthsForYear]
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_306, [
                              _createElementVNode("button", {
                                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                                onClick: ($event: any) => (_ctx.calculateIncomeType('hours', j, w))
                              }, "RUN", 8, _hoisted_307),
                              _createElementVNode("div", _hoisted_308, [
                                _hoisted_309,
                                _createVNode(_component_VueNumberFormat, {
                                  value: hour.monthlyIncome,
                                  "onUpdate:value": ($event: any) => ((hour.monthlyIncome) = $event),
                                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                                }, null, 8, ["value", "onUpdate:value", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_310, [
                                (j > 0)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplex",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplex",
                                      onClick: ($event: any) => (_ctx.removeIncomeType('hours', j, w))
                                    }, _hoisted_313, 8, _hoisted_311))
                                  : _createCommentVNode("", true),
                                (customer.incomeType.hours.length == j + 1 && j != 2)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplex",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplex",
                                      onClick: ($event: any) => (_ctx.addIncomeType('hours', w))
                                    }, _hoisted_316, 8, _hoisted_314))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 256))
                      ], 8, _hoisted_297)
                    ]),
                    _createElementVNode("div", _hoisted_317, [
                      _createElementVNode("div", {
                        class: "collapse multi-collapse",
                        id: 'multiCollapseExample2' + w
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.week, (week, j) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_319, [
                            _createElementVNode("table", _hoisted_320, [
                              _hoisted_321,
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_322, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_VueNumberFormat, {
                                      value: week.paymentForWeek,
                                      "onUpdate:value": ($event: any) => ((week.paymentForWeek) = $event),
                                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((week.weeksForMonth) = $event)
                                    }, null, 8, _hoisted_323), [
                                      [_vModelText, week.weeksForMonth]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((week.monthsForYear) = $event)
                                    }, null, 8, _hoisted_324), [
                                      [_vModelText, week.monthsForYear]
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_325, [
                              _createElementVNode("button", {
                                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                                onClick: ($event: any) => (_ctx.calculateIncomeType('week', j, w))
                              }, "RUN", 8, _hoisted_326),
                              _createElementVNode("div", _hoisted_327, [
                                _hoisted_328,
                                _createVNode(_component_VueNumberFormat, {
                                  value: week.monthlyIncome,
                                  "onUpdate:value": ($event: any) => ((week.monthlyIncome) = $event),
                                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                                }, null, 8, ["value", "onUpdate:value", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_329, [
                                (j > 0)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplex",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplex",
                                      onClick: ($event: any) => (_ctx.removeIncomeType('week', j, w))
                                    }, _hoisted_332, 8, _hoisted_330))
                                  : _createCommentVNode("", true),
                                (customer.incomeType.week.length == j + 1 && j != 2)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplea",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplea",
                                      onClick: ($event: any) => (_ctx.addIncomeType('week', w))
                                    }, _hoisted_335, 8, _hoisted_333))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 256))
                      ], 8, _hoisted_318)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_336, [
                  _createElementVNode("p", _hoisted_337, [
                    _createElementVNode("a", {
                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                      "data-bs-toggle": "collapse",
                      href: '#multiCollapseExample3' + w,
                      role: "button",
                      "aria-expanded": "false",
                      "aria-controls": "multiCollapseExample3"
                    }, "BYWEEKLY", 8, _hoisted_338),
                    _createElementVNode("button", {
                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-border-[#00a0da]",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": '#multiCollapseExample4' + w,
                      "aria-expanded": "false",
                      "aria-controls": "multiCollapseExample4"
                    }, "MONTHS", 8, _hoisted_339)
                  ]),
                  _createElementVNode("div", _hoisted_340, [
                    _createElementVNode("div", _hoisted_341, [
                      _createElementVNode("div", {
                        class: "collapse multi-collapse",
                        id: 'multiCollapseExample3' + w
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.biweekly, (b, j) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_343, [
                            _createElementVNode("table", _hoisted_344, [
                              _hoisted_345,
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_346, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_VueNumberFormat, {
                                      value: b.paymentForWeekly,
                                      "onUpdate:value": ($event: any) => ((b.paymentForWeekly) = $event),
                                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((b.byWeeklyForYear) = $event)
                                    }, null, 8, _hoisted_347), [
                                      [_vModelText, b.byWeeklyForYear]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((b.monthsForYear) = $event)
                                    }, null, 8, _hoisted_348), [
                                      [_vModelText, b.monthsForYear]
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_349, [
                              _createElementVNode("button", {
                                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                                onClick: ($event: any) => (_ctx.calculateIncomeType('biweekly', j, w))
                              }, "RUN", 8, _hoisted_350),
                              _createElementVNode("div", _hoisted_351, [
                                _hoisted_352,
                                _createVNode(_component_VueNumberFormat, {
                                  value: b.monthlyIncome,
                                  "onUpdate:value": ($event: any) => ((b.monthlyIncome) = $event),
                                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                                }, null, 8, ["value", "onUpdate:value", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_353, [
                                (j > 0)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplex",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplex",
                                      onClick: ($event: any) => (_ctx.removeIncomeType('biweekly', j, w))
                                    }, _hoisted_356, 8, _hoisted_354))
                                  : _createCommentVNode("", true),
                                (customer.incomeType.biweekly.length == j + 1 && j != 2)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#multiCollapseExampleaaa",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExampleaaa",
                                      onClick: ($event: any) => (_ctx.addIncomeType('biweekly', w))
                                    }, _hoisted_359, 8, _hoisted_357))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 256))
                      ], 8, _hoisted_342)
                    ]),
                    _createElementVNode("div", _hoisted_360, [
                      _createElementVNode("div", {
                        class: "collapse multi-collapse",
                        id: 'multiCollapseExample4' + w
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.incomeType.months, (m, j) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_362, [
                            _createElementVNode("table", _hoisted_363, [
                              _hoisted_364,
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_365, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_VueNumberFormat, {
                                      value: m.paymentForMonths,
                                      "onUpdate:value": ($event: any) => ((m.paymentForMonths) = $event),
                                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((m.monthsForYear) = $event)
                                    }, null, 8, _hoisted_366), [
                                      [_vModelText, m.monthsForYear]
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_367, [
                              _createElementVNode("button", {
                                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                                onClick: ($event: any) => (_ctx.calculateIncomeType('months', j, w))
                              }, "RUN", 8, _hoisted_368),
                              _createElementVNode("div", _hoisted_369, [
                                _hoisted_370,
                                _createVNode(_component_VueNumberFormat, {
                                  value: m.monthlyIncome,
                                  "onUpdate:value": ($event: any) => ((m.monthlyIncome) = $event),
                                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                                }, null, 8, ["value", "onUpdate:value", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_371, [
                                (j > 0)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#collapseExamplex",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplex",
                                      onClick: ($event: any) => (_ctx.removeIncomeType('months', j, w))
                                    }, _hoisted_374, 8, _hoisted_372))
                                  : _createCommentVNode("", true),
                                (customer.incomeType.months.length == j + 1 && j != 2)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                                      "data-bs-toggle": "collapse",
                                      href: "#multiCollapseExamplexx",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExamplexx",
                                      onClick: ($event: any) => (_ctx.addIncomeType('months', w))
                                    }, _hoisted_377, 8, _hoisted_375))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 256))
                      ], 8, _hoisted_361)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_378, [
                    _createElementVNode("button", {
                      class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                      onClick: ($event: any) => (_ctx.calculateTotalMonthlyIncome(w))
                    }, "DONE", 8, _hoisted_379),
                    _createElementVNode("div", _hoisted_380, [
                      _hoisted_381,
                      _createVNode(_component_VueNumberFormat, {
                        value: customer.incomeType.totalMonthlyIncome,
                        "onUpdate:value": ($event: any) => ((customer.incomeType.totalMonthlyIncome) = $event),
                        disabled: "",
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                        class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                      }, null, 8, ["value", "onUpdate:value", "options"])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        }), 256)),
        (_ctx.financialInformation.customers.length < 4)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              "data-bs-toggle": "collapse",
              href: "#multiCollapseExamplea",
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "multiCollapseExamplea",
              class: "tw-font-bold tw-mt-5 tw-text-[#545454] tw-border tw-border-[#545454] tw-rounded-full tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-w-full",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addScenarioCustomer()))
            }, "+ ADD CUSTOMER"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_382, [
          _hoisted_383,
          _createElementVNode("div", _hoisted_384, [
            _createElementVNode("div", _hoisted_385, [
              _createElementVNode("button", {
                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.calculateTotalCustomerMonthlyIncome()))
              }, "DONE"),
              _createElementVNode("div", _hoisted_386, [
                _hoisted_387,
                _createVNode(_component_VueNumberFormat, {
                  value: _ctx.financialInformation.totalCustomerMonthlyIncome,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.financialInformation.totalCustomerMonthlyIncome) = $event)),
                  disabled: "",
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_388, [
          _hoisted_389,
          _createElementVNode("div", _hoisted_390, [
            (_ctx.selection.selectedUser)
              ? (_openBlock(), _createElementBlock("table", _hoisted_391, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selection.selectedUser.familyMonthExpenses, (user) => {
                      return (_openBlock(), _createElementBlock("tr", _hoisted_392, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.values, (u, k) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_393, [
                            (k == 0)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: u.type,
                                  value: u.value,
                                  disabled: u.type == 'text'
                                }, null, 8, _hoisted_394))
                              : _createCommentVNode("", true),
                            (k == 1)
                              ? (_openBlock(), _createBlock(_component_VueNumberFormat, {
                                  key: 1,
                                  onChange: ($event: any) => (_ctx.fillData(u)),
                                  value: u.value,
                                  "onUpdate:value": ($event: any) => ((u.value) = $event),
                                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                                }, null, 8, ["onChange", "value", "onUpdate:value", "options"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.listFamilyMonthExpenses.length == 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_395, _hoisted_397))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_398, [
              _createElementVNode("div", _hoisted_399, [
                (_ctx.selection.selectedUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_400, [
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selection.selectedUser.ctfms(_ctx.selection.selectedUser)))
                      }, "RUN"),
                      _createElementVNode("div", _hoisted_401, [
                        _hoisted_402,
                        _createVNode(_component_VueNumberFormat, {
                          disabled: true,
                          class: _normalizeClass(["tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3", { 'tw-text-[#E6E7E9]': _ctx.selection.selectedUser == null || !_ctx.selection.selectedUser.showTotalFamily, 'tw-text-black': _ctx.selection.selectedUser !== null && _ctx.selection.selectedUser.showTotalFamily }]),
                          value: _ctx.selection.selectedUser.totalFamilyMonthExpenses,
                          "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selection.selectedUser.totalFamilyMonthExpenses) = $event)),
                          options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                        }, null, 8, ["value", "class", "options"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_403, [
          _hoisted_404,
          _createElementVNode("div", _hoisted_405, [
            _createElementVNode("div", _hoisted_406, [
              _createElementVNode("button", {
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submitFormula('propertyTotalExample', $event))),
                class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[15px] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white"
              }, "CALCULATION")
            ]),
            _hoisted_407,
            _createElementVNode("div", _hoisted_408, [
              _createElementVNode("div", _hoisted_409, [
                _hoisted_410,
                _createVNode(_component_VueNumberFormat, {
                  disabled: true,
                  class: _normalizeClass(["tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3", { 'tw-text-[#E6E7E9]': _ctx.selection.selectedUser == null || !_ctx.selection.selectedUser.showTotalFamily, 'tw-text-black': _ctx.selection.selectedUser !== null && _ctx.selection.selectedUser.showTotalFamily }]),
                  value: _ctx.financialInformation.propertyEstimatedMortgage,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.financialInformation.propertyEstimatedMortgage) = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                }, null, 8, ["value", "class", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_411, [
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.submitScenario($event))),
            disabled: !_ctx.scenarioValid,
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER", 8, _hoisted_412)
        ])
      ])
    ])
  ]))
}